/* @jsx h */
import {
  defineComponent,
  h,
  onMounted,
  onUnmounted,
  watch,
  watchEffect,
} from "vue";
import { RouterView, useRoute } from "vue-router";
import { Navbar } from "@app/vue/components/index";
import { ChatBubbles } from "@app/vue/components/ChatBubbles/index";
import { useAuth } from "@app/vue/providers/index";
import { useShop } from "@app/vue/providers/ShopConnection";
import { useNativeBridge } from "@app/vue/providers/NativeBridge";
import { isPackaged } from "@lemmonhq/orders";
import { isMobileTabBarPrototypeEnabled } from "./Navbar/mobileTabBarPrototype";

export const Layout = defineComponent({
  name: "Layout",
  setup() {
    const {} = useAuth();
    const route = useRoute();
    const shop = useShop();
    const nativeBridge = useNativeBridge();
    // Keep the app icon badge in step with the pending reservation requests,
    // which ShopConnection polls and refreshes on focus. Layout wraps every
    // signed-in screen, so this runs whenever the app is in use. The ids let
    // the app cancel notifications of requests that are no longer pending.
    watch(
      () => shop.pendingReservationRequestIds.value,
      (pendingRequestIds) => {
        void nativeBridge?.setBadge(pendingRequestIds);
      },
      { immediate: true },
    );
    watchEffect(() => {
      document.documentElement.toggleAttribute(
        "data-full-height",
        !!route.meta.fullHeight,
      );
    });
    onUnmounted(() =>
      document.documentElement.removeAttribute("data-full-height"),
    );
    const env = (window as any).lemmonEnv;
    let safeAreaTop = env?.packagingInfo?.statusBarHeight || 0;
    const hasNoSafeArea = safeAreaTop > 0;
    const useMobileTabBar = isMobileTabBarPrototypeEnabled();
    onMounted(() => {
      document.head.append(
        `<style>html, body { overscroll-behavior: none; } </style>`,
      );
      if (hasNoSafeArea) {
        // to get rid of overscroll on native apps
        // Calculate and set safe-area-top based on lemmonEnv statusBarHeight
        document.documentElement.style.setProperty(
          "--safe-area-top",
          `${safeAreaTop}px`,
        );
      }
    });
    return () => {
      const paddingTopStyle = isPackaged
        ? "calc(0px + var(--safe-area-top, 0px))"
        : "0px";

      return (
        <div
          style={{ paddingTop: paddingTopStyle }}
          class={[
            "flex flex-1 h-full min-h-screen flex-col",
            route.meta.fullHeight ? "!h-[100dvh] !min-h-0 overflow-hidden" : "",
            useMobileTabBar
              ? "max-[698px]:!h-[100dvh] max-[698px]:!min-h-0 max-[698px]:overflow-hidden"
              : "",
            useMobileTabBar
              ? "max-[698px]:pb-[calc(3.75rem+env(safe-area-inset-bottom))]"
              : "",
          ]}
        >
          <>
            <div
              class={[
                "border-b",
                hasNoSafeArea ? "pb-2" : "py-2",
                useMobileTabBar ? "max-[698px]:border-b-0 max-[698px]:p-0" : "",
              ]}
            >
              <Navbar />
            </div>
            <RouterView />
            {true ? null : <ChatBubbles />}
          </>
        </div>
      );
    };
  },
});
